"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _Tabs = require("./components/zapier/Tabs");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _constants = require("@insided/shared/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ZapierIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ZapierIntegration, _Component);

  var _super = _createSuper(ZapierIntegration);

  function ZapierIntegration(props) {
    var _props$isInstalled, _props$apiKey;

    var _this;

    (0, _classCallCheck2.default)(this, ZapierIntegration);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: (_props$isInstalled = props.isInstalled) !== null && _props$isInstalled !== void 0 ? _props$isInstalled : false,
      apiKey: (_props$apiKey = props.apiKey) !== null && _props$apiKey !== void 0 ? _props$apiKey : '',
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false
    };
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ZapierIntegration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.get('/integration/zapier/settings');

              case 4:
                res = _context.sent;

                if ('key' in res.data) {
                  this.setState({
                    apiKey: res.data.key,
                    isInstalled: true
                  });
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                this.setState({
                  isInstalled: false,
                  messageType: 'error',
                  message: 'Unable to retrieve Zapier API key.'
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      this.setState({
        activeTab: selectedTab
      });
    }
  }, {
    key: "onResetAccessToken",
    value: function onResetAccessToken() {
      this.setState({
        apiKey: '',
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "onClickCopy",
    value: function onClickCopy() {
      this.copyTextToClipboard(this.state.apiKey);
      this.setState({
        messageType: 'success',
        message: 'API key copied.'
      });
    }
  }, {
    key: "onClickRevoke",
    value: function () {
      var _onClickRevoke = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var errorMessage, _data$error, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                errorMessage = 'Something went wrong. Please try again.';
                _context2.prev = 2;
                _context2.next = 5;
                return _axios.default.delete('/integration/zapier/settings');

              case 5:
                this.setState({
                  isInstalled: false,
                  apiKey: '',
                  showUninstallModal: false,
                  messageType: 'success',
                  message: 'You’ve revoked the API key.'
                });
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                data = _context2.t0.response.data;
                this.setState({
                  messageType: 'error',
                  message: (_data$error = data.error) !== null && _data$error !== void 0 ? _data$error : errorMessage,
                  showUninstallModal: false
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function onClickRevoke() {
        return _onClickRevoke.apply(this, arguments);
      }

      return onClickRevoke;
    }()
  }, {
    key: "onGenerateApiKey",
    value: function () {
      var _onGenerateApiKey = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var errorMessage, response, _data$error2, data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                errorMessage = 'Something went wrong. Please try again.';
                _context3.prev = 2;
                _context3.next = 5;
                return _axios.default.post('/integration/zapier/settings');

              case 5:
                response = _context3.sent;
                this.setState({
                  isInstalled: true,
                  apiKey: response.data.key,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: 'You’ve generated an API key.'
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Zapier API key generated'
                });

                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](2);
                data = _context3.t0.response.data;
                this.setState({
                  messageType: 'error',
                  message: (_data$error2 = data.error) !== null && _data$error2 !== void 0 ? _data$error2 : errorMessage,
                  showUninstallModal: false
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 10]]);
      }));

      function onGenerateApiKey() {
        return _onGenerateApiKey.apply(this, arguments);
      }

      return onGenerateApiKey;
    }()
  }, {
    key: "copyTextToClipboard",
    value: function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        ZapierIntegration.fallbackCopyTextToClipboard(text);
        return;
      }

      navigator.clipboard.writeText(text).then(function () {}, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var region = this.props.region;
      var _this$state = this.state,
          isInstalled = _this$state.isInstalled,
          messageType = _this$state.messageType,
          message = _this$state.message,
          activeTab = _this$state.activeTab,
          apiKey = _this$state.apiKey,
          showUninstallModal = _this$state.showUninstallModal;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Zapier",
        appLogoName: "zapier-l",
        appContainerBackgroundColor: "#FF4F00",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: (0, _preact.h)("div", null, "Connect now", (0, _preact.h)(_assets.default, {
            icon: "externalLink",
            width: 16,
            height: 16,
            customClass: "installation__connect_now_icon"
          })),
          className: "installation__button_cta",
          onClick: function onClick() {
            return window.open('https://zapier.com/apps/insided/integrations', '_blank');
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Zap templates', 'Connect with Zapier'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          isInstalled: isInstalled
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          apiKey: apiKey,
          isInstalled: isInstalled,
          onClickCopy: function onClickCopy() {
            return _this2.onClickCopy();
          },
          onClickRevoke: function onClickRevoke() {
            return _this2.setState({
              showUninstallModal: true
            });
          },
          onGenerateApiKey: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.onGenerateApiKey();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          region: region
        })],
        uninstallModal: (0, _preact.h)(_reactModal.default, {
          isOpen: showUninstallModal,
          onClose: function onClose() {
            return _this2.closeUninstallModal();
          }
        }, (0, _preact.h)("div", {
          className: "uninstall-confirmation-modal"
        }, (0, _preact.h)("h3", {
          className: "modal-title"
        }, "Revoke API key"), (0, _preact.h)("div", {
          className: "modal-description"
        }, (0, _preact.h)("p", null, "Revoking your API key for Zapier means that any Zaps based on existing connections in Zapier will stop working. To make the Zaps work again, you will have to reconnect your connection with", ' ', _constants.PLATFORM_BRAND_NAME, " in Zapier using a new API key.")), (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "warning",
          title: "Revoke",
          className: "qa-revoke-api-key",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.onClickRevoke();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }))
        }), (0, _preact.h)(_Button.default, {
          size: "medium",
          title: "Cancel",
          onClick: function onClick() {
            return _this2.closeUninstallModal();
          },
          className: "qa-cancel-uninstall-and-delete-credentials"
        })))
      });
    }
  }], [{
    key: "fallbackCopyTextToClipboard",
    value: function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text; // Avoid scrolling to bottom

      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }
  }]);
  return ZapierIntegration;
}(_preact.Component);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("span", null, (0, _preact.h)("p", null, "Zapier is an online automation tool that connects your favorite apps, such as Gmail, Slack, Mailchimp, and more. You can connect two or more apps to automate repetitive tasks without coding or relying on developers to build the integration."), (0, _preact.h)("p", null, "Our Zapier integration enables you to trigger workflows based on community activities, as well as use other apps to trigger behaviours on ", _constants.PLATFORM_BRAND_NAME, ". The possibilities are endless, but we see many customers successfully use Zapier to improve internal collaboration with messaging tools like Slack, automate workflows for ideation with product tools like JIRA, and forward community member registrations and activity to marketing automation/CRM tools like Marketo and Hubspot."));
};

var _default = ZapierIntegration;
exports.default = _default;